import React from 'react';
import Single from './Single.js';


function ProfilePhotoUpload(props) {
    const { multiple = false } = props;

    return (
        <div className={`relative`}>
            {
                multiple === false && (
                    <Single {...props} />
                )
            }
        </div>
    );
}
export default ProfilePhotoUpload;